import { Component, OnInit, Output } from '@angular/core';

const TARIFARIO_DATA: any = [
  { tipo_medidor_instalado: 'Medidor Diafragma G1.6', comentario: 'Jove SAC', costo_prueba: 'S/ 171.91'},
  //{tipo_medidor_instalado: 'Medidor Diafragma G1.6', comentario: 'JOVE CONTRATISTAS Y SERVICIOS GENERALES S.A.C', costo_prueba: 'S/ 170.80'},
  { tipo_medidor_instalado: 'Medidor Diafragma G4', comentario: 'Instituto Nacional de Calidad - INACAL', costo_prueba: 'S/ 366.77'},
];

@Component({
  selector: 'app-recibo-digital',
  templateUrl: './meter-contrast-ad.component.html',
  styleUrls: ['./meter-contrast-ad.component.scss']
})

export class MeterContrastAdComponent implements OnInit {

  displayedColumns: string[] = ['tipo_medidor_instalado', 'costo_prueba', 'comentario'];
  dataSource = TARIFARIO_DATA; 
  constructor() { }

  ngOnInit() {
  }
}